export default function (count: number, multiple = 's', single = '') {
  return count == 1 ? single : multiple
}
